import { useEffect } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { toastifyFnWithImage } from 'common/utilities/utils';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import isEmpty from 'lodash/isEmpty';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';

const { TOAST_NOTIFICATION } = CART_PAGE_CONSTANTS;
const imageTemp = <ImageComponent srcFile={IMAGE_PATH.Error} />;

export const useShowToastMsg = removedAddOnItems => {
  useEffect(() => {
    if (!isEmpty(removedAddOnItems)) {
      toastifyFnWithImage(translateWithI18Next(TOAST_NOTIFICATION.ADDON_REMOVED), imageTemp, 'addon-removed-toast');
    }
  }, [removedAddOnItems]);
};
